import { useState, useEffect, useRef } from "react";

function Follower() {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const mouse = useRef({ x: 0, y: 0 });
  const current = useRef({ x: 0, y: 0 });
  const animRef = useRef();

   useEffect(() => {
    const handleMouseMove = (e) => {
      mouse.current = { x: e.clientX, y: e.clientY };
    };
    window.addEventListener("mousemove", handleMouseMove);

    const animate = () => {
      const speed = 0.1;

      current.current.x += (mouse.current.x - current.current.x) * speed;
      current.current.y += (mouse.current.y - current.current.y) * speed;

      setPos({ x: current.current.x, y: current.current.y });
      animRef.current = requestAnimationFrame(animate);
    };

    animRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      cancelAnimationFrame(animRef.current);
    };
  }, []);


  return (
    <div
      style={{
        position: "fixed",
        left: pos.x,
        top: pos.y,
        pointerEvents: "none",
        zIndex: 9999
      }}
      className="Follower"
    >
    </div>
  );
}

export default Follower;